<template>
  <div>
    <b-modal
      id="weekly-prizes-modal"
      ref="modal"
      title=""
      hide-footer
      hide-header
    >
      <div class="header">
        <span class="close-icon"
              @click="$bvModal.hide('weekly-prizes-modal')">
          <img src="@/assets/svg/close-black.svg"
               aria-label="close">
        </span>

        <h3>
          <img src="@/assets/green-hint.png" />

          Еженедельный розыгрыш
        </h3>

        <div class="prizes-wrapper">
          <div class="prize-card">
              <div class="prize-img">
                <img src="@/assets/ozon-3.png" class="img" />
              </div>
              <div class="prize-title">
                Сертификат OZON <br> 3 000 ₽
              </div>
              <div class="prize-text">
                На шампуры, угли  <br> или набор для барбекю
              </div>
          </div>

          <div class="prize-card">
              <div class="prize-img">
                <img src="@/assets/grill-2.png" class="img" />
              </div>
              <div class="prize-title">
                Набор шампуров
              </div>
              <div class="prize-text">
                Для настоящего ценителя <br> кулинарии и вкусовых <br> сочетаний
              </div>
          </div>

          <div class="prize-card">
              <div class="prize-img">
                <img src="@/assets/ozon-5.png" class="img" />
              </div>
              <div class="prize-title">
                Сертификат OZON <br> 5 000 ₽
              </div>
              <div class="prize-text">
                На шампуры, угли  <br> или набор для барбекю
              </div>
          </div>

          <div class="prize-card">
              <div class="prize-img">
                <img src="@/assets/tefal.png" class="img" />
              </div>
              <div class="prize-title">
                Гриль Tefal
              </div>
              <div class="prize-text">
                Король мангала. <br> Твой личный шеф-повар <br>для дома
              </div>
          </div>
        </div>

        <div class="subtext">
          График распределения призов согласно правилам 

          <b-link :href="rulesLink" class="rules-link"
                 target="_blank">Акции</b-link>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex"

  export default {
    props: ['text'],

    data() {
      return {
        rulesLink: '',
      }
    },

    mounted() {
      this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
        if (modalId == "weekly-prizes-modal") {
          this.rulesLink = this.storeRules.url
        }
      })
    },

    computed: {
      ...mapGetters({
        storeRules: 'rules'
      }),
    },

    methods: {
    }
  }
</script>

<style scoped lang="scss">
.header {
  flex-direction: column;
  width: 100%;

  .close-icon {
    float: right;
    cursor: pointer;
    transition: .4s all;
    margin-right: 5px;

    &:hover {
      opacity: .85;
    }
  }

  h3 {
    width: 100%;
    margin-top: 50px;
    margin-bottom: 30px;
    font-weight: 800;
    font-family: $regular;
    font-size: 18px;
    text-transform: uppercase;
    text-align: center;
  }
}

.prizes-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.prize-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  max-width: 200px;
  margin-left: 6px;
  margin-right: 7px;
  height: fit-content;

  @media(max-width: 576px) {
    max-width: 130px;
  }
}

.prize-title {
  color: #B4722D;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  line-height: 110%;
  text-align: center;

  @media(max-width: 678px) {
    font-size: 16px;
    line-height: 110%;

    &.smaller {
      margin-top: -6px;
    }
  }
}

.prize-text {
  color: #4E4E4E;
  font-size: 15px;
  font-weight: 400;
  line-height: 120%;
  text-align: center;
  margin-bottom: 35px;

  @media(max-width: 678px) {
    font-size: 13px;
  }
}

.prize-img {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background: linear-gradient(180deg, #00712F 0%, #093B1F 129.68%);
  padding: 25px;
  margin-bottom: 15px;
  height: 175px;
  max-width: 200px;

  @media(max-width: 1200px) {
    img {
      height: 100%;
      width: 100%;
    }
  }

  @media(max-width: 678px) {
    max-width: 135px;
    height: 130px;

    img {
      height: auto;
    }

    &.main {
      max-width: 300px;
    }
  }

  img {
    width: 100%;
  }

  &.main {
    background: transparent;
  }
}
</style>
